<el-dialog
  title="提示"
  :visible.sync="centerDialogVisible"
  width="30%"
  center>
<span>需要注意的是内容是默认不居中的</span>
<span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span>
</el-dialog>

<template>
  <div id="footer" class="container-fluid">
    <div class="hidden-xs" style="display: flex; align-items: center">
      <div class="col-xs-12 col-sm-12 col-md-9 wow zoomIn">
        <div class="logo">
          <img src="@/assets/img/资源 18.png" alt="logo图">
        </div>
        <!--    <p class="title">昭通吉比特市场经营管理有限公司</p>-->
        <p class="address_tel_fax">
          <span v-if="information" style="margin-left: 10px">{{ '地址：' + information.address }}</span>
          <!--          <span style="margin-left: 10px">传真：8888-88888888</span>-->
        </p>
        <p class="email_wx">
          <span v-if="information" style="margin-left: 10px">{{ '电话：' + information.mobile }}</span>
          <span v-if="information" style="margin-left: 10px">{{ '邮箱：' + information.email }}</span>
          <!--          <span style="margin-left: 10px">公司微信号：吉比特市场</span>-->
          <!--          <span style="margin-left: 10px">公司抖音：吉比特市场</span>-->
        </p>
        <p class="copy">Copyright &copy; 2023 - 2033 昭通吉比特市场经营管理有限公司
        </p>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-3 wow zoomIn" style="width: 600px; margin-left: 100px; display: flex; flex-direction: row">

        <div style="display: flex; flex-direction: column; align-items: center;">
          <img class="col-xs-12 col-sm-12 col-md-4 wow zoomIn" style="width: 110px"
               src="@/assets/img/抖音号.png"
               alt="logo图">
          <div style="margin-top: 10px; flex: 1">官方抖音</div>
        </div>

        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
          <img class="col-xs-12 col-sm-12 col-md-4 wow zoomIn" style="width: 110px;  margin-left: 20px"
               src="@/assets/img/公众号.png"
               alt="logo图">
          <div style="margin-top: 16px; margin-left: 15px; flex: 1">官方公众号</div>
        </div>

        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
          <img class="col-xs-12 col-sm-12 col-md-4 wow zoomIn" style="width: 110px; margin-left: 20px"
               src="@/assets/img/微信号.png"
               alt="logo图">
          <div style="margin-top: 16px; margin-left: 15px; flex: 1">官方微信号</div>
        </div>

      </div>
    </div>

    <div class="visible-xs">
      <div class="col-xs-12">
        <div class="logo">
          <img src="@/assets/img/资源 18.png" alt="logo图">
        </div>
        <!--    <p class="title">昭通吉比特市场经营管理有限公司</p>-->
        <p class="address_tel_fax;">
          <span v-if="information">{{ '地址：' + information.address }}</span>
        </p>
        <p class="address_tel_fax;">
          <span v-if="information">{{ '电话：' + information.mobile }}</span>
        </p>
        <!--        <p class="address_tel_fax;">-->
        <!--          <span>传真：8888-88888888</span>-->
        <!--        </p>-->
        <p class="address_tel_fax;">
          <span v-if="information">{{ '邮箱：' + information.email }}</span>
        </p>
        <!--        <p class="address_tel_fax;">-->
        <!--          <span>公司微信号：吉比特市场</span>-->
        <!--        </p>-->
        <!--        <p class="address_tel_fax;">-->
        <!--          <span>公司抖音：吉比特市场</span>-->
        <!--        </p>-->

        <p class="address_tel_fax">
          <span>Copyright &copy; 2023 - 2033 昭通吉比特市场经营管理有限公司</span>
        </p>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 wow zoomIn"
           style="display: flex; flex-direction: column; justify-content: center; align-items: center">
        <img style="width: 150px; margin-top: 20px" src="@/assets/img/抖音号.png"
             alt="logo图">
        <img style="width: 150px; margin-top: 20px" src="@/assets/img/公众号.png"
             alt="logo图">
        <img style="width: 150px; margin-top: 30px; margin-bottom: 50px" src="@/assets/img/微信号.png"
             alt="logo图">
      </div>

    </div>

  </div>


</template>
<script>
export default {
  name: "Footer",
  props: {
    information: {information: Object}
  },
  data() {
    return {
      centerDialogVisible: false
    };
  },
  methods: {
    logo_click() {
      console.log('...')
      this.centerDialogVisible = true
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #000000;
  overflow: hidden;
  /*text-align: left;*/
  display: flex;
  align-items: center;
  justify-content: center;
  /*padding: 0 100px;*/
}

.logo {
  width: 136px;
  height: 30px;
  margin: 30px 0 20px 0;;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 30px 0 20px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue